import { useContext } from "react";
import { ApiContext } from "src/providers/api-provider";

export const useApi = () => useContext(ApiContext);
